import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {FormsModule} from '@angular/forms';

import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {InterceptorProvider} from './Providers/Interceptor/interceptor';
import {GlobalErrorHandler} from './Providers/Errors/global-error-handler';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {IonicStorageModule} from '@ionic/storage-angular';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {ComponentsModule} from './Components/components.module';
import {PipesModule} from './Pipes/pipes.module';
import {DirectivesModule} from './Directives/directives.module';

import {NgApexchartsModule} from 'ng-apexcharts';
import {MarkdownModule} from 'ngx-markdown';

import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

import es from '@angular/common/locales/es';
import {registerLocaleData} from '@angular/common';

registerLocaleData(es);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ComponentsModule,
    PipesModule,
    DirectivesModule,
    NgApexchartsModule,
    MarkdownModule.forRoot(),
    IonicStorageModule.forRoot(),
    TranslateModule.forRoot(),
    IonicModule.forRoot({
      mode: 'ios',
      backButtonText: '',
      backButtonDefaultHref: '',
    }),
    AppRoutingModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: HTTP_INTERCEPTORS, useClass: InterceptorProvider, multi: true}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
